import React from 'react';
import { useIntl } from 'react-intl';
import { musicServicesByMusicAPIID } from 'fym-shared/src/music-services/allMusicServices';
import { TypedMemo } from '../../common/types';
import { CatalogItem } from '../../../redux/api/fymAPI.types';
import { Cover } from '../components/primitives/Cover';
import { catalogArtworkSrc } from '../../smartLinks/catalog/catalogArtwork';
import { artistHomeMessages as messages } from './artistHomeMessages';
import { CatalogAttentionRow } from './catalogSummary';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CatalogAttentionListProps {
  rows: CatalogAttentionRow[];
  onFixLinks: () => void;
  onCreateLink: (item: CatalogItem) => void;
}

/** Up to three releases that need work: a missing link ("Fix links") or no smartlink (design a1). */
const CatalogAttentionListComponent: React.FC<CatalogAttentionListProps> = ({ rows, onFixLinks, onCreateLink }) => {
  const intl = useIntl();
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className={styles.attention}>
      {rows.map(({ item, reason }) => {
        const isMissing = reason.kind === 'missingLinks';
        const detail = isMissing
          ? intl.formatMessage(messages.catalogMissingServices, {
              services: intl.formatList(
                reason.services.map((service) => musicServicesByMusicAPIID[service]?.name ?? service),
                { type: 'disjunction' }
              ),
            })
          : intl.formatMessage(messages.catalogNoSmartlinkYet);
        return (
          <div key={item.uuid} className={styles.attentionRow}>
            <Cover src={catalogArtworkSrc(item, 30)} label={item.title} size={30} radius={7} />
            <div className={styles.attentionText}>
              <b>{item.title}</b>
              <small>{detail}</small>
            </div>
            <button
              type="button"
              className={styles.linkButton}
              onClick={isMissing ? onFixLinks : () => onCreateLink(item)}
            >
              {intl.formatMessage(isMissing ? messages.catalogFixLinks : messages.catalogCreateSmartlink)}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export const CatalogAttentionList = TypedMemo(CatalogAttentionListComponent);
